module.exports = __webpack_public_path__ + "img/pic_zakupy.cfc18e4c.svg";